const DEV_URLS = [ '.dev.', 'localhost' ];

export const useIsDev = () => {
  const domain = window?.location?.origin || '';

  return DEV_URLS.some(urls => domain.includes(urls));
};